import type { CommissionDistributionResourceDictionary } from "CommissionDistribution/Translations/ResourceDictionary";

export const CommissionDistributionCzechResourcesDictionary: CommissionDistributionResourceDictionary =
	{
		Dialog: {
			Title: "Tabulka dělení provizí",
			Subtitle:
				"Určete účastníky a poměr dělení provize z této smlouvy a potvrďte správnost uvedených údajů. Součet musí být 100 %.",
			SaveButton: "Uložit",
			CancelButton: "Zrušit",
			AddParticipant: "Přidat účastníka",
			ValidationOver100:
				"Součet podílů přesahuje 100 % — zkontrolujte zadané hodnoty.",
			ConfirmCheckboxTitle: "Potvrzuji správnost tabulky dělení provizí.",
			ConfirmCheckboxBody:
				"Souhlasím s uvedeným rozdělením provize z této smlouvy a beru na vědomí, že po potvrzení bude smlouva předána ke zprovíznění.",
			ConfirmNote:
				"Potvrzení je vyžadováno správcem obchodů před odevzdáním smlouvy do zprovíznění.",
			Realizator: "Realizátor",
			RealizatorRequired: "povinný",
			RealizatorAutoNote: "dopočítáno",
			ParticipantTypePlaceholder: "— Typ účasti —",
			ConsultantPlaceholder: "— Konzultant —",
			CloseAriaLabel: "Zavřít",
			RemoveAriaLabel: "Odebrat",
		},
		Validation: {
			ConsultantRequired: "Vyberte konzultanta.",
			AmountRequired: "Zadejte podíl.",
			AmountOutOfRange: "Podíl musí být v rozmezí 0 až 100.",
			DuplicateConsultant: "Konzultant již byl přidán.",
			SumExceedsHundred: "Součet podílů přesahuje 100 %.",
		},
		Types: {
			Header: "Typy účasti",
			Realizator: {
				Name: "Realizátor",
				Description: "Sjednatel smlouvy. Vždy povinný, podíl se dopočítá.",
			},
			ContractTipster: {
				Name: "Tipař smlouvy",
				Description: "Doporučil tuto konkrétní smlouvu realizátorovi.",
			},
			ClientTipster: {
				Name: "Tipař klienta",
				Description: "Přivedl klienta — platí pro všechny jeho smlouvy.",
			},
			InvitedSpecialist: {
				Name: "Zvaný specialista",
				Description: "Přizvaný odborník, jednorázová platba mimo strukturu.",
			},
		},
		SuccessDialog: {
			ConfirmedTitle: "TDP potvrzena",
			ConfirmedSubtitle: "Smlouva bude odeslána na Back Office ke zprovíznění.",
			SavedTitle: "TDP uložena",
			SavedSubtitle:
				"Rozdělení provize bylo uloženo. TDP zatím není potvrzena.",
			SummaryTitle: "Potvrzené rozdělení",
			BackToContract: "Zpět na smlouvu",
		},
		Errors: {
			General: "Nastala chyba při ukládání rozdělení provize.",
			ContractOrRealizatorNotFound:
				"Smlouva nebo její realizátor nebyl nalezen.",
			TooManyParticipants:
				"Lze přidat maximálně 2 účastníky kromě realizátora.",
			DuplicateConsultant: "Každý konzultant může být uveden pouze jednou.",
			SumExceedsHundred: "Součet podílů přesahuje 100 %.",
			AmountOutOfRange: "Podíl musí být v rozmezí 0 až 100.",
			RealizatorCannotBeParticipant:
				"Realizátor nemůže být uveden jako další účastník.",
		},
		Columns: {
			ParticipationType: "Typ účasti",
			Consultant: "Konzultant",
			Share: "Podíl na provizi",
		},
	};
